import { render, staticRenderFns } from "./PopupMaster.vue?vue&type=template&id=68723a7a"
import script from "./PopupMaster.ts?vue&type=script&lang=ts&external"
export * from "./PopupMaster.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports